<template>
  <div class="close-btn">
    <router-link v-if="useDefault" to="/dashboard">
      <div class="closebtn"><span class="fa-solid fa-times"></span></div>
    </router-link>

    <div v-else class="closebtn" @click="$emit('close-clicked')">
      <span class="fa-solid fa-times"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    useDefault: {
      type: Boolean,
      default: true, // Keep default redirect behavior for all existing usages
    },
  },
};
</script>

<style scoped>
.close-btn {
  position: relative;
  justify-content: right;
  right: 5px;
  float: right;
  cursor: pointer;
  z-index: 9 !important;
}

.close-btn a {
  position: relative;
  color: var(--closebtnhover-color);
  font-size: 20px;
  text-decoration: none;
  top: -3px;
}

.close-btn a:hover {
  color: var(--closebtn-color);
}

.closebtn {
  position: relative;
  top: -2px;
  border: 2px solid #f53939;
  border-radius: 25px;
  left: 5px;
  width: 22px;
  height: 22px;
  text-align: center;
  background-color: #f53939;
  color: white;
  margin: 0 auto !important;
}

.closebtn .txt {
  position: relative;
  font-size: 14px;
  top: -6px;
}

.closebtn .fa-solid {
  position: relative;
  font-size: 16px;
  top: -5px;
}

.closebtn:hover {
  box-shadow: 0px 1px 2px 0px red;
  background-color: crimson;
  color: white;
}

@media only screen and (max-width: 600px) {
  .closebtn .txt {
    position: relative;
    top: -6px;
  }
}
</style>
